export default "__VITE_ASSET__DMJX6EOR__"